import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router';
import { clsx } from '../clsx';
import styles from './TextLink.module.css';

interface Common {
  /** `accent` is the default link; `muted` the quiet secondary link ("Wiederherstellungscode nutzen", "Anderes Konto"). */
  tone?: 'accent' | 'muted' | undefined;
  /** 12.5 px (default) or 12 px (links inside panels and footers). */
  size?: 'default' | 'small' | undefined;
}

type ButtonLinkProps = { as: 'button' } & ButtonHTMLAttributes<HTMLButtonElement> & Common;
type RouterLinkProps = { as?: 'link' | undefined } & LinkProps & Common;
type ExternalLinkProps = { as: 'a' } & AnchorHTMLAttributes<HTMLAnchorElement> & Common;

export type TextLinkProps = ButtonLinkProps | RouterLinkProps | ExternalLinkProps;

/** The underlined accent text link of the screens ("Passwort vergessen?", "Wiederherstellungscode nutzen"). */
export function TextLink(props: TextLinkProps) {
  const tone = props.tone ?? 'accent';
  const size = props.size ?? 'default';
  const classes = (extra: string | undefined) =>
    clsx(styles.link, tone === 'muted' && styles.muted, size === 'small' && styles.small, extra);
  if (props.as === 'button') {
    const { as: _as, tone: _tone, size: _size, className, type = 'button', ...rest } = props;
    return <button type={type} className={classes(className)} {...rest} />;
  }
  if (props.as === 'a') {
    const { as: _as, tone: _tone, size: _size, className, ...rest } = props;
    return <a className={classes(className)} {...rest} />;
  }
  const { as: _as, tone: _tone, size: _size, className, ...rest } = props;
  return <Link className={classes(className)} {...rest} />;
}
